import { _plus } from '@/helpers/bigNumber'
import { apificateDate } from '@/helpers/formatDate'

export const date = state => (key) => {
  return state._[key].date
}

export const amount = state => (key) => {
  return state._[key].amount
}

export const totalAmount = state => {
  return state.list.reduce((acc, k) => {
    return _plus(acc, Number(state._[k].amount))
  }, 0)
}

export const apificate = state => {
  return state.list.map(k => {
    return {
      date: apificateDate(state._[k].date),
      amount: state._[k].amount
    }
  })
}
